"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const inferContentItemFieldKey_1 = require("../read/inferContentItemFieldKey");
exports.nestedContentPopulation = (block, contentFeed, contentItem, contentSlotNumber) => {
    if (!contentFeed || !contentItem || !block) {
        throw new Error(!contentFeed
            ? 'ContentFeed is not set'
            : !contentItem
                ? 'ContentItem not set'
                : !block
                    ? 'Block not set'
                    : 'Unknown error');
    }
    if (block.fieldType === 'ad' ||
        (block.attrs &&
            Object.keys(block.attrs).includes('osys:field:source:disable'))) {
        return Object.assign({}, block);
    }
    return Object.assign(Object.assign({}, block), { active: false, childBlocks: (block.childBlocks || []).map(b => {
            return exports.nestedContentPopulation(b, contentFeed, contentItem, contentSlotNumber);
        }), contentFeed, contentFieldKey: block.type === 'field' && contentItem
            ? inferContentItemFieldKey_1.inferContentItemFieldKey(block, contentItem)
            : null, contentItem, contentSlotNumber: typeof contentSlotNumber === 'number' ? contentSlotNumber : null, contentStr: null });
};
//# sourceMappingURL=nestedContentPopulation.js.map